import { db } from "../../../service/API";

export class ProfileMailTransferConnector {
  constructor(userData) {
    this.socId = userData.socId;
  }

  getSenderMailData() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileMailTransferConnector/getMailData/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("getMailData failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("getMailData failed with error : " + err.message);
        });
    });
  }

  insertSenderMailData(mailObject) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileMailTransferConnector/insertMailData/", {
        mail: mailObject,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insertMailData failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("insertMailData failed with error : " + err.message);
        });
    });
  }

  updateSenderMailData(mailObject) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileMailTransferConnector/updateMailData/", {
        sid: this.socId,
        mail: mailObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("updateMailData failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("updateMailData failed with error : " + err.message);
        });
    });
  }

  // call after error when sending email
  disableSenderMail() {
    return new Promise((resolve, reject) => {
      db.put("/ProfileMailTransferConnector/disableMail/", { sid: this.socId })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("disableMail failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("disableMail failed with error : " + err.message);
        });
    });
  }

  sendMail(senderObject, mailObject) {
    return new Promise((resolve, reject) => {
      db.post("/sendmail", { sender: senderObject, mail: mailObject })
        .then((response) => {
          if (response.status == 200) {
            return resolve("Mail sent");
          } else {
            return reject("send mail failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("send mail failed with error : " + err.message);
        });
    });
  }
}
